import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-twentytwo-twentythree',
  templateUrl: './twentytwo-twentythree.component.html',
  styleUrls: ['./twentytwo-twentythree.component.scss']
})
export class TwentytwoTwentythreeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
